import { Label, Input } from "@educrib/firefly";
import FieldGroup from "./FieldGroup";

export default function Thumbnail({ label = true }: { label?: boolean }) {
  return (
    <FieldGroup>
      {label && <Label>Thumbnail</Label>}
      <Input type="text" name="thumbnail" placeholder="Thumbnail" />
    </FieldGroup>
  );
}
